import { Fragment, memo, ReactElement } from 'react';
import ActiveStep from './active-step';

interface FormDetailProps {
  step?: number;
  onBack: () => void;
  onNext: () => void;
}

const FormDetailComponent = ({ step, onBack, onNext }: FormDetailProps): ReactElement => {
  return (
    <Fragment>
      <ActiveStep step={step} onBack={onBack} onNext={onNext} />
    </Fragment>
  );
};

FormDetailComponent.displayName = 'Civil Status- Form component';

const FormDetail = memo(FormDetailComponent);

export default FormDetail;
